const strategies = [
  { name: 'EMA Cross', type: 'Trend', desc: 'Fast/slow EMA crossover', active: true },
  { name: 'RSI Mean Reversion', type: 'Mean Reversion', desc: 'Oversold buy, overbought sell', active: false },
  { name: 'MACD Momentum', type: 'Momentum', desc: 'MACD signal line crossover', active: false },
  { name: 'TDR Advanced', type: 'Multi-Factor', desc: 'Flagship multi-indicator system', active: false },
  { name: 'Bollinger Breakout', type: 'Volatility', desc: 'Band expansion breakout entries', active: false },
];

export default function StrategySelectorMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Select Strategy</div>
      <div className="platform-mock-body" style={{ padding: '0.75rem 1rem' }}>
        {strategies.map((s) => (
          <div
            key={s.name}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.625rem 0.75rem',
              marginBottom: '0.375rem',
              borderRadius: '0.5rem',
              background: s.active ? 'rgba(157,78,221,0.1)' : '#181825',
              border: s.active ? '1px solid rgba(157,78,221,0.35)' : '1px solid rgba(255,255,255,0.06)',
            }}
          >
            <div
              style={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                border: s.active ? '2px solid #9d4edd' : '2px solid #4b5563',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              {s.active && (
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#9d4edd' }} />
              )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem' }}>
                <span style={{ fontSize: '0.75rem', fontWeight: 600, color: s.active ? '#e5e7eb' : '#9ca3af' }}>
                  {s.name}
                </span>
                <span style={{
                  fontSize: '0.5625rem',
                  fontWeight: 600,
                  color: '#6b7280',
                  background: 'rgba(255,255,255,0.04)',
                  padding: '0.1rem 0.375rem',
                  borderRadius: '0.25rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                }}>
                  {s.type}
                </span>
              </div>
              <div style={{ fontSize: '0.625rem', color: '#6b7280', marginTop: '0.125rem' }}>
                {s.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="platform-mock-caption">Built-in strategies available in Quanthop. Select one to configure its parameters.</div>
    </div>
  );
}
